<!--
	PageAlert.svelte

    Must be manually placed on all "pages" that want to use Alerts (for now)
    TODO: investigate dynamic instantiation!
-->

<script>
    import { onMount } from 'svelte';
    import { scale, fade } from 'svelte/transition';
    import { storeAlert, clearAlert, isCancelled } from '../../stores/AlertsStore';
    import { ERROR, WARNING, INFO, TEXT } from '../../stores/AlertsStore';

    // TCARE components

    // SMUI components
	import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiAlertCircle, mdiAlert, mdiInformation, mdiClose } from '@mdi/js';

    // export let alert;     // no more need to pass this in as a prop

    $: alert = $storeAlert;
    $: backgroundColor = getBackgroundColor(alert);
    $: svgPath = getSvgPath(alert);

    const ERROR_COLOR = '#cc0000';
    const WARNING_COLOR = '#ff5522';
    const INFO_COLOR = '#00aa00';
    const TEXT_COLOR = '#888888';
    
    onMount(() => {
    })

    const onAlertClick = () => {
        $isCancelled = true;
        clearAlert();
    }

    const getBackgroundColor = (alert) => {
        if (!alert) return "";
        let color = '';
        switch (alert.type) {
            case ERROR: color = ERROR_COLOR; break;
            case WARNING: color = WARNING_COLOR; break;
            case INFO: color = INFO_COLOR; break;
            case TEXT: color = TEXT_COLOR; break;
            default: color = '';
        }
        return color;
    }

    const getSvgPath = (alert) => {
        if (!alert) return "";
        let path = '';
        switch (alert.type) {
            case ERROR: path = mdiAlertCircle; break;
            case WARNING: path = mdiAlert; break;
            case INFO: path = mdiInformation; break;
            // TEXT has no icon
            default: path = '';
        }
        return path;
    }

</script>

<style>

    /* appears fixed bottom centered  */
    .page-alert-wrapper {
        position: fixed;
        display: flex;
        z-index: 999;
        width: 100%;
        bottom: 40px;
        justify-content: center;
    }

    .page-alert {
        display: flex;
        z-index: 999;
        user-select: none;
        padding: 5px 10px;
        color: var(--tcare-white);
        border-radius: 5px;
        font-size: 1em;
    }


    .alert-icon {
        width: 26px;
        height: 26px;
        margin: 0px 0px;
    }

    :global(.alert-icon svg) {
        fill: var(--tcare-white);
        outline: none;
    }

    .alert-message {
        padding: 0px 20px;
    }
    
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- need a wrapper to center the alert at bottom -->
{#if alert}
    <div class="page-alert-wrapper">
        <div class="page-alert ai-center fs-1-5 fw-400" 
            on:click={() => onAlertClick()}
            in:scale="{{ duration: 250, opacity: 0.5, start: 0.98 }}" out:fade="{{ duration: 250 }}"
            style={'background-color: ' + backgroundColor}
        >

            {#if alert.type !== TEXT}
                <div class="alert-icon flex-center">
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={svgPath} /></Icon>	
                </div>
            {/if}

            <div class="alert-message">
                {alert.message}
            </div>            

            {#if alert.type !== TEXT}
                <div class="alert-icon flex-center">
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiClose} /></Icon>	
                </div>
            {/if}

        </div>
    </div>
{/if}
